import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Form = () => {
  const defaultForm = {
    lastName: '',
    firstName: '',
    email: '',
    tel: '',
    message: '',
    age: '',
    weight: '',
    height: '',
  };
  const [formData, setFormData] = useState(defaultForm);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const query = new URLSearchParams(formData).toString();
    try {
      await fetch(
        `https://script.google.com/macros/s/AKfycbwdexqLfyFpF45r4fQkJdG2tTU8GOSqsISepSw-tcVVmaHA6bZ8Q-MoSPKSLuJQoLo/exec?${query}`,
        {
          method: 'GET',
          mode: 'no-cors',
        }
      );
      setFormData(defaultForm);
      toast.success('✅ Wiadomość została wysłana!');
    } catch (err) {
      toast.error('❌ Wystąpił błąd przy wysyłaniu wiadomości.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="kontakt" class=" p-6 fade-in">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-3xl font-bold mb-4">Kontakt</h2>
        <form
          class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-900 p-6 rounded-xl shadow-xl"
          onSubmit={handleSubmit}
        >
          <input
            name="firstName"
            type="text"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Imię"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="lastName"
            type="text"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Nazwisko"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Adres email"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="tel"
            type="tel"
            value={formData.tel}
            onChange={handleChange}
            placeholder="Telefon"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="age"
            type="number"
            value={formData.age}
            onChange={handleChange}
            placeholder="Wiek"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="weight"
            type="number"
            value={formData.weight}
            onChange={handleChange}
            placeholder="Waga (kg)"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <input
            name="height"
            type="number"
            value={formData.height}
            onChange={handleChange}
            placeholder="Wzrost (cm)"
            class="p-3 rounded bg-gray-700 text-white"
            required
          />
          <textarea
            name="message"
            placeholder="Wiadomość"
            value={formData.message}
            onChange={handleChange}
            class="p-3 rounded bg-gray-700 text-white md:col-span-2 h-32"
          ></textarea>
          <button
            disabled={loading}
            type="submit"
            class="bg-blue-600 hover:bg-blue-500 text-white p-3 rounded-md md:col-span-2 transition"
          >
            {loading ? 'Wysyłanie...' : 'Wyślij wiadomość'}
          </button>
        </form>
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </section>
  );
};

export default Form;
